"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var eventEmitter = new eventemitter3_1.default();
var Emitter = {
    on: function (event, fn) { return eventEmitter.on(event, fn); },
    once: function (event, fn) { return eventEmitter.once(event, fn); },
    off: function (event) { return eventEmitter.off(event); },
    emit: function (event, payload) { return eventEmitter.emit(event, payload); }
};
Object.freeze(Emitter);
exports.default = Emitter;
